module.exports = __webpack_public_path__ + "img/bg.d58b242a.jpg";